import React from 'react';
import axios from "axios";
import {
    getFromLocalStorage,
    appendScript,
    getPercentageChange, getPercentageDirection, 
    getNicePeriod, generateMetricHTML,
    str_replace
} from './Utilities';

class OverallMetrics extends React.Component {

    constructor(props){
        super(props);
        const metrics = {
            "visits": 0,
            "registrations": 0,
            "conversion": 0,
        }
        this.state = {
            "metrics": metrics,
            "segmentID": this.props.segmentID
        }
    }

    componentDidMount(){        
        this.getData();
    }

    getData(){
        var url = "react/process?endpoint=members/visit/totals&turnoffdebug=1&overall=1&segmentID="+this.state.segmentID;
        axios.get(url).then(response => this.formatData(response.data));  
    }

    formatData(data){
        var metrics = {
            "visits": data.metrics.visits,
            "registrations": data.metrics.registrations,
            "conversion": data.metrics.conversion,
        };

        this.setState({
            "metrics": metrics
        });      
    }

    render(){ 
        return (
            <div className="row">
                <div className="col-md-4">
                    <h5 className="mt-1 mb-0 text-truncate">Total Unique Visits</h5>
                    <h6>
                        {generateMetricHTML(this.state.metrics.visits)}
                    </h6>
                </div>
                <div className="col-md-4">
                    <h5 className="mt-1 mb-0 text-truncate">Total Unique Logins</h5>
                    <h6>
                        {generateMetricHTML(this.state.metrics.registrations)}
                    </h6> 
                </div>
                <div className="col-md-4">
                    <h5 className="mt-1 mb-0 text-truncate">Conversion</h5>
                    <h6>
                        {generateMetricHTML(this.state.metrics.conversion, "%")}
                    </h6> 
                </div>
            </div>
        );
    }
}

class OverallMemberActivity extends React.Component {   

    constructor(props){
        super(props);

        const metrics = {
            "activities": 0,
            "members": 0,
        }
        this.state = {
            "metrics": metrics,
            "segmentID": props.segmentID
        }
    }

    componentDidMount(){        
        this.getData();
    }

    getData(){
        var url = "react/process?endpoint=members/activity/totals&turnoffdebug=1&includeonetime=1&overall=1&segmentID="+this.state.segmentID;
        axios.get(url).then(response => this.formatData(response.data));  
    }

    formatData(data){
        var metrics = {
            "activities": data.metrics.activities,
            "members": data.metrics.members,
        };

        this.setState({
            "metrics": metrics
        });      
    }

    render() {

        return (
            <div className="row">
                <div className="col-md-4">
                    <h5 className="mt-1 mb-0 text-truncate">Total Member Activity</h5>
                    <h6>
                        {generateMetricHTML(this.state.metrics.activities)}
                    </h6>
                </div>
                <div className="col-md-4">
                    <h5 className="mt-1 mb-0 text-truncate">Total Members</h5>
                    <h6>
                        {generateMetricHTML(this.state.metrics.members)}
                    </h6> 
                </div>
                <div className="col-md-4">
                </div>
            </div>
        );
    }
}

class LoginsForPeriod extends React.Component {   

    constructor(props){
        super(props);

        const metrics = {
            "visits": 0,
            "registrations": 0,
            "conversion": 0,
            "set": false
        }
        this.state = {
            "current": metrics,
            "previous": metrics,
            "percentages": {"set": false},
            "percentageDirections": {"set": false},
            "segmentID": props.segmentID,
            "period": props.period
        }
    }

    componentDidMount(){        
        this.getData();
    }

    componentDidUpdate(prevProps, prevState, snapshot){
        if((this.state.current.set && this.state.previous.set) && !this.state.percentages.set){
            this.calculatePercentageChanges();
        }
    }

    getData(){
        var current_url = "react/process?endpoint=members/visit/totals&turnoffdebug=1&uniquemember=0&segmentID="+this.state.segmentID+"&period="+this.state.period;
        axios.get(current_url).then(current_response => this.formatData(current_response.data, "current"));  

        var prev_url = "react/process?endpoint=members/visit/totals&turnoffdebug=1&uniquemember=0&PreviousPeriod=1&segmentID="+this.state.segmentID+"&period="+this.state.period;
        axios.get(prev_url).then(prev_response => this.formatData(prev_response.data, "previous"));   
    }

    formatData(data, period){
        var data_for_period = {
            "visits": data.metrics.visits,
            "registrations": data.metrics.registrations,
            "conversion": data.metrics.conversion,
            "set": true
        };

        if(period === "current") this.setState({"current": data_for_period});
        if(period === "previous") this.setState({"previous": data_for_period});    
    }

    calculatePercentageChanges(){
        var visits = getPercentageChange(this.state.current.visits, this.state.previous.visits);
        var registrations = getPercentageChange(this.state.current.registrations, this.state.previous.registrations);
        var conversion = getPercentageChange(this.state.current.conversion, this.state.previous.conversion);

        var percentages = {
            "visits": str_replace("-", "", visits),
            "registrations": str_replace("-", "", registrations),
            "conversion": str_replace("-", "", conversion),
            "set": true
        };
        var percentageDirections = {
            "visits": getPercentageDirection(visits),
            "registrations": getPercentageDirection(registrations),
            "conversion": getPercentageDirection(conversion),
            "set": true
        }
        this.setState({
            "percentages": percentages,
            "percentageDirections": percentageDirections
        });
    }

    render() {
        if(this.state.percentages.set && this.state.percentageDirections.set){
            return (
                <div>
                    <div className="row">

                        <div className="col-md-4">
                            <div>
                                <h5 className="mt-1 mb-0 text-truncate">Visits</h5>
                                <h6>
                                    <span data-plugin="counterup" className="min-width-60">{this.state.current.visits}</span>
                                </h6>
                            </div>
                            <div className="percentage">
                                <h6 className={this.state.percentageDirections.visits}>
                                    <span data-plugin="counterup" className="min-width-60">{this.state.percentages.visits}%</span>
                                </h6> 
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div>
                                <h5 className="mt-1 mb-0 text-truncate">Logins</h5>
                                <h6>
                                    <span data-plugin="counterup" className="min-width-60">{this.state.current.registrations}</span>
                                </h6>
                            </div>
                            <div className="percentage">
                                <h6 className={this.state.percentageDirections.registrations}>
                                    <span data-plugin="counterup" className="min-width-60">{this.state.percentages.registrations}%</span>
                                </h6> 
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div>
                                <h5 className="mt-1 mb-0 text-truncate">Conversions</h5>
                                <h6>
                                    <span data-plugin="counterup" className="min-width-60">{this.state.current.conversion}</span>
                                </h6>
                            </div>
                            <div className="percentage">
                                <h6 className={this.state.percentageDirections.conversion}>
                                    <span data-plugin="counterup" className="min-width-60">{this.state.percentages.conversion}%</span>
                                </h6> 
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
             return(
                <div className="row">
                    <div className="col-md-4"></div>
                    <div className="loading col-md-4">
                        <div className="react-loading" ></div>
                    </div>
                    <div className="col-md-4"></div>
                </div>
            );
        }
    }
}

class NewVsReturning extends React.Component {   

    constructor(props){
        super(props);

        const metrics = {
            "new": 0,
            "returning": 0,
            "set": false
        }
        this.state = {
            "current": metrics,
            "previous": metrics,
            "percentages": {"set": false},
            "percentagesDirection": {"set": false},
            "segmentID": props.segmentID,
            "period": props.period
        }
    }

    componentDidMount(){        
        this.getData();
    }

    componentDidUpdate(prevProps, prevState, snapshot){
        if((this.state.current.set && this.state.previous.set) && !this.state.percentages.set){
            this.calculatePercentageChanges();
        }
    }

    getData(){
        var current_url = "react/process?endpoint=login/stats/totals?turnoffdebug=1&group_on=type&segmentID="+this.state.segmentID+"&period="+this.state.period;
        axios.get(current_url).then(current_response => this.formatData(current_response.data, "current"));  

        var prev_url = "react/process?endpoint=login/stats/totals?turnoffdebug=1&group_on=type&PreviousPeriod=1&segmentID="+this.state.segmentID+"&period="+this.state.period;
        axios.get(prev_url).then(prev_response => this.formatData(prev_response.data, "previous"));   
    }

    formatData(data, period){
        var newKey = (data.totals[0] && parseInt(data.totals[0].type) === 1) ? 0 : 1;
        var returningKey = (data.totals[0] && parseInt(data.totals[0].type) === 2) ? 0 : 1;

        var data_for_period = {
            "new": data.totals[newKey] ? data.totals[newKey].signups : 0,
            "returning": data.totals[returningKey] ? data.totals[returningKey].signups : 0,
            "set": true
        };

        if(period === "current") this.setState({"current": data_for_period});
        if(period === "previous") this.setState({"previous": data_for_period});    
    }

    calculatePercentageChanges(){
        var newPercent = getPercentageChange(this.state.current.new, this.state.previous.new);
        var returningPercent = getPercentageChange(this.state.current.returning, this.state.previous.returning);

        var percentageDirections = {
            "new": getPercentageDirection(newPercent),
            "returning": getPercentageDirection(returningPercent),
            "set": true
        }
        var percentages = {
            "new": str_replace("-", "", newPercent),
            "returning": str_replace("-", "", returningPercent),
            "set": true
        };
        this.setState({
            "percentages": percentages,
            "percentageDirections": percentageDirections
        });
    }

    render(){
        if(this.state.percentages.set && this.state.percentageDirections.set){
            return (
                <div>
                    <div className="row">
                        <div className="col-md-4">
                            <div>
                                <h5 className="mt-1 mb-0 text-truncate">New</h5>
                                <h6>
                                    <span data-plugin="counterup" className="min-width-60">{this.state.current.new}</span>
                                </h6>
                            </div>
                            <div className="percentage">
                                <h6 className={this.state.percentageDirections.new}>
                                    <span data-plugin="counterup" className="min-width-60">{this.state.percentages.new}%</span>
                                </h6>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div>
                                <h5 className="mt-1 mb-0 text-truncate">Returning</h5>
                                <h6>
                                    <span data-plugin="counterup" className="min-width-60">{this.state.current.returning}</span>
                                </h6>
                            </div>
                            <div className="percentage">
                                <h6 className={this.state.percentageDirections.returning}>
                                    <span data-plugin="counterup" className="min-width-60">{this.state.percentages.returning}%</span>
                                </h6>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return(
                <div className="row">
                    <div className="col-md-4"></div>
                    <div className="loading col-md-4">
                        <div className="react-loading" ></div>
                    </div>
                    <div className="col-md-4"></div>
                </div>
            );
        }    
    }
}

class RegistrationsByDevice extends React.Component {

    constructor(props){
        super(props);

        const metrics = {
            "new": 0,
            "returning": 0,
            "set": false
        }
        this.state = {
            "current": metrics,
            "previous": metrics,
            "percentages": {"set": false},
            "percentagesDirection": {"set": false},
            "segmentID": props.segmentID,
            "period": props.period
        }
    }

    componentDidMount(){        
        this.getData();
    }

    componentDidUpdate(prevProps, prevState, snapshot){
        if((this.state.current.set && this.state.previous.set) && !this.state.percentages.set){
            this.calculatePercentageChanges();
        }
    }

    getData(){
        var current_url = "react/process?endpoint=login/stats/totals?turnoffdebug=1&group_on=mobile&segmentID="+this.state.segmentID+"&period="+this.state.period;
        axios.get(current_url).then(current_response => this.formatData(current_response.data, "current"));  

        var prev_url = "react/process?endpoint=login/stats/totals?turnoffdebug=1&group_on=mobile&PreviousPeriod=1&segmentID="+this.state.segmentID+"&period="+this.state.period;
        axios.get(prev_url).then(prev_response => this.formatData(prev_response.data, "previous"));   
    }

    formatData(data, period){
        var desktopKey = (data.totals[0] && parseInt(data.totals[0].type) === 0) ? 0 : 1;
        var mobileKey = (data.totals[0] && parseInt(data.totals[0].type) === 1) ? 0 : 1;

        var data_for_period = {
            "desktop": data.totals[desktopKey] ? data.totals[desktopKey].signups : 0,
            "mobile": data.totals[mobileKey] ? data.totals[mobileKey].signups : 0,
            "set": true
        };

        if(period === "current") this.setState({"current": data_for_period});
        if(period === "previous") this.setState({"previous": data_for_period});    
    }

    calculatePercentageChanges(){
        var desktop = getPercentageChange(this.state.current.desktop, this.state.previous.desktop);
        var mobile = getPercentageChange(this.state.current.mobile, this.state.previous.mobile);

        var percentageDirections = {
            "desktop": getPercentageDirection(desktop),
            "mobile": getPercentageDirection(mobile),
            "set": true
        }
        var percentages = {
            "desktop": str_replace("-", "", desktop),
            "mobile": str_replace("-", "", mobile),
            "set": true
        };
        this.setState({
            "percentages": percentages,
            "percentageDirections": percentageDirections
        });
    }

    render() {
       if(this.state.percentages.set && this.state.percentageDirections.set){
            return (
                <div>
                    <div className="row">
                        <div className="col-md-4">
                            <div>
                                <h5 className="mt-1 mb-0 text-truncate">Desktop</h5>
                                <h6>
                                    <span data-plugin="counterup" className="min-width-60">{this.state.current.desktop}</span>
                                </h6>
                            </div>
                            <div className="percentage">
                                <h6 className={this.state.percentageDirections.desktop}>
                                    <span data-plugin="counterup" className="min-width-60">{this.state.percentages.desktop}%</span>
                                </h6>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div>
                                <h5 className="mt-1 mb-0 text-truncate">Mobile</h5>
                                <h6>
                                    <span data-plugin="counterup" className="min-width-60">{this.state.current.mobile}</span>
                                </h6>
                            </div>
                            <div className="percentage">
                                <h6 className={this.state.percentageDirections.mobile}>
                                    <span data-plugin="counterup" className="min-width-60">{this.state.percentages.mobile}%</span>
                                </h6>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return(
                <div className="row">
                    <div className="col-md-4"></div>
                    <div className="loading col-md-4">
                        <div className="react-loading" ></div>
                    </div>
                    <div className="col-md-4"></div>
                </div>
            );
        }    
    }

}

class ReportsSegmentOverviewMetrics extends React.Component { 

    constructor(props){
        super(props);

        this.state = {
            "segmentID": null,
            "period": null
        }
    }

    componentDidMount(){        
        appendScript("thirdparty/Minton-assets/js/app.js");
        this.getData();
    }

    getData(){
        var filters = getFromLocalStorage("report_data");
        var segmentID = null;
        var period = null;
        if(filters && Object.keys(filters).length > 0){
            if(filters.ChooseActivities && filters.ChooseActivities.Segment && filters.ChooseActivities.Segment.ID){
                segmentID = parseInt(filters.ChooseActivities.Segment.ID)               
            }
            period = filters.DateRange ? filters.DateRange : "7+DAY";
            this.setState({
                "segmentID": segmentID,
                "period": period
            });
        }
    }

    render() {

        if(this.state.segmentID && this.state.period){
            var nicePeriod = getNicePeriod(this.state.period);
            var backURL = "/dashboard/segment/insights/"+this.state.segmentID;

            return (
                <React.Fragment>
                    {/*<p><a href={backURL}><strong>&lt;&lt; Back to Segment Insights</strong></a></p>*/}

                    <div className="overall-metrics">
                        <h3 className="mt-3">Overall Visitor Metrics</h3>
                        <OverallMetrics segmentID={this.state.segmentID} />
                        <hr />

                        <h3 className="mt-3">Overall Member Activity</h3>     
                        <OverallMemberActivity segmentID={this.state.segmentID} />
                    </div>
                        
                    <hr />

                    <div className="row">
                        <div className="col-md-6 first">
                            <h3 className="mt-3">Logins for Period ({nicePeriod})</h3>
                            <LoginsForPeriod segmentID={this.state.segmentID} period={this.state.period} />
                        </div>    
                        <div className="col-md-6 second">
                            <h3 className="mt-3">New vs Returning ({nicePeriod})</h3>
                            <NewVsReturning segmentID={this.state.segmentID} period={this.state.period} />
                        </div>
                    </div>   
                    <hr />     
                    <div className="row">
                        <div className="col-md-6 first">
                            <h3 className="mt-3">Registrations by Device ({nicePeriod})</h3>
                            <RegistrationsByDevice segmentID={this.state.segmentID} period={this.state.period} />
                        </div>    
                    </div>

                </React.Fragment>
            );
        } else {
            return(
                <div className="row">
                    <div className="col-md-4"></div>
                    <div className="loading col-md-4">
                        <div className="react-loading big" style={this.props.loaderStyle}></div>
                    </div>
                    <div className="col-md-4"></div>
                </div>
            );
        }
    }
}

ReportsSegmentOverviewMetrics.defaultProps = {
    loaderStyle: {
        "height": "200px"
    }
};

export default ReportsSegmentOverviewMetrics;
